export default __webpack_public_path__ + "static/media/move-arrow-black.2db71fce.svg";